<!-- H5批注列表 -->
<template lang="pug">
van-popup.notationPopup(v-model="popupShow" closeable :overlay="false")
  .notationList
    .titleRow 批注列表
      van-button.sortBtn(v-if="screen.sortType" icon="descending" size="small" type="info" plain @click="setSort(0)")
      van-button.sortBtn(v-if="!screen.sortType" icon="ascending" size="small" type="info" plain @click="setSort(1)")
    .content
      van-search(v-model="screen.keyword" placeholder="请输入文件名或问题描述" show-action @search="onSearch")
        template(#action)
          div(@click="openScreen") 筛选
      van-pull-refresh.dataList(v-model="refreshing" v-loading="loading" @refresh="onRefresh")
        van-list(v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad")
          .listItem(v-for="(item,index) in dataList" :key="item.index" @click="toIssueContent(item)")
            .Logo {{item.fileType}}
            .top
              span(:style="`color: ${queColor(item.queStatusId)}`") [{{item.queStatus}}]
              span.fileName {{item.fileName}}
              i.el-icon-more(@click.stop="openMore(item)")
            .remark {{ item.checkContent }}
            .footer
              span 修改人：{{dealModifierList(item.modifierList)}}
              span.createDate 创建时间：{{ item.createDate }}
  //- 筛选弹框
  screenPopup(ref="screenPopup" @callback="updateScreen")
  //- 更多弹框
  moreSheet(ref="moreSheet" @refresh="getDataList_update")
</template>

<script>
import { mapState } from "vuex";
import { statusColor } from "@/CommonDP/pages/appView/issueH5/issue.js";
import { windowOpen } from "@/CommonDP/utils/docPublic.js";
import screenPopup from "@/CommonDP/pages/appView/issueH5/components/screenPopup.vue";
import moreSheet from "@/CommonDP/pages/appView/issueH5/components/moreSheet.vue";
import mongeService from "@/CommonDP/mongeView/service/monge-service";

// 表单
function FormData() {
  return {
    keyword: "",
    pageNum: 1,
    pageSize: 10,
    sortType: 1 // 0升序 1降序
  };
}

export default {
  components: { screenPopup, moreSheet },
  data() {
    return {
      popupShow: false,
      screen: new FormData(), // 筛选条件
      dataList: [],
      totalPage: 0, // 总页数
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // 触底
    finished() {
      return this.screen.pageNum + 1 > this.totalPage;
    }
  },
  mounted() {},
  methods: {
    // 问题状态颜色
    queColor(queStatusId) {
      return statusColor(queStatusId);
    },
    // 打开事件
    open(params) {
      this.init(params);
      this.popupShow = true;
    },
    // 初始化
    init(params) {
      let { prjId, fileId } = params || {};
      this.screen = new FormData();
      this.screen = { ...this.screen, ...params };
      this.$nextTick(() => {
        this.initPopup(prjId, fileId);
        this.onSearch();
      });
      // 特殊参数：分享、流程
      let { sharerId, flowInstanceId, i } = this.$route.query || {};
      this.screen = { ...this.screen, sharerUserId: sharerId, flowInstanceId, shareId: i };
    },
    // 初始化弹框
    initPopup(prjId, fileId) {
      this.$refs.screenPopup.init(prjId, fileId);
    },

    // 查询数据列表
    async getDataList() {
      this.loading = true;
      try {
        const { data, totalPage } = await mongeService.notationlist(this.screen);
        let list = data || [];
        this.dataList = [...this.dataList, ...list];
        this.totalPage = totalPage || 0;
      } finally {
        this.loading = false;
      }
    },
    // 查询数据列表_更新
    async getDataList_update() {
      this.loading = true;
      try {
        let { pageNum, pageSize } = this.screen;
        let total = pageNum * pageSize;
        const params = { ...this.screen, pageNum: 1, pageSize: total };
        const { data, totalPage } = await mongeService.notationlist(params);
        let list = data || [];
        this.dataList = [...list];
      } finally {
        this.loading = false;
      }
    },
    // 触底加载
    async onLoad() {
      if (this.refreshing) {
        this.dataList = [];
        this.refreshing = false;
        this.screen.pageNum = 0;
      }
      this.screen.pageNum++;
      await this.getDataList();
    },
    // 查询
    onSearch() {
      this.screen.pageNum = 1;
      this.dataList = [];
      this.getDataList();
    },
    // 下拉刷新
    async onRefresh() {
      try {
        this.onSearch();
      } finally {
        this.refreshing = false;
      }
    },
    // 打开筛选弹框
    openScreen() {
      this.$refs.screenPopup.popupShow = true;
    },
    // 更新筛选条件
    updateScreen(newScreen) {
      this.screen = { ...this.screen, ...newScreen };
      this.onSearch();
    },
    // 设置排序
    setSort(sortType) {
      this.screen.sortType = sortType;
      this.onSearch();
    },

    // 进入批注详情
    toIssueContent(item) {
      let { questionId } = item || {};
      const issueItem = { questionId };
      windowOpen({ path: "/project-issue/issueContent", query: issueItem });
    },
    // 打开更多弹框
    openMore(item) {
      this.$refs.moreSheet.open(item);
    },
    // 修改人
    dealModifierList(modifierList) {
      return modifierList?.map((e) => e.modifierName).join() || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.notationPopup {
  position: fixed;
  top: 50px;
  bottom: 0;
  left: 0;
  transform: none;
}

.notationList {
  width: 100vw;
  height: 100%;
  position: relative;
  .titleRow {
    height: 46px;
    padding: 0 10px;
    line-height: 46px;
    border-bottom: 1px solid #f5f6fa;
    display: flex;
    align-items: center;
    .sortBtn {
      border: none;
      font-size: 15px;
    }
  }
  .content {
    height: calc(100% - 46px);
    padding-top: 5px;
    background-color: #f5f6fa;
    .dataList {
      height: calc(100% - 55px);
      overflow: auto;
      .van-list {
        height: 100%;
        padding: 0 10px;
      }
    }
  }
}

::v-deep .listItem {
  width: 100%;
  height: 100px;
  padding: 0 10px;
  margin-top: 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(56, 115, 254, 0.06);
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  .top {
    display: flex;
    flex-direction: row;
    line-height: 30px;
    .fileName {
      margin-left: 8px;
      margin-right: 8px;
      flex: 1 1;
      white-space: nowrap;
      overflow-x: auto;
      scrollbar-width: none;
    }
    .el-icon-more {
      line-height: 30px;
      margin-left: auto;
    }
  }
  .remark {
    line-height: 30px;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .footer {
    font-size: 12px;
    color: var(--info-color, #909399);
    line-height: 30px;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    .createDate {
      margin-left: 5px;
    }
  }
}

.Logo {
  width: 60px;
  height: 20px;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  color: #ffffff;
  font-size: 14px;
  background-color: rgba(250, 78, 78, 0.74);
  position: absolute;
  top: 5px;
  left: -15px;
  transform: rotate(-45deg);
  opacity: 0.8;
}

::v-deep .van-popup__close-icon--top-right {
  top: 12px;
  right: 12px;
}
</style>
